import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Link } from 'react-router-dom';
import MatchScoreIndicator from './MatchScoreIndicator';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const CardLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: block;
  height: 100%;
  animation: ${fadeIn} 0.5s ease-out forwards;
`;

const Card = styled.div`
  background-image: url(${props => props.imageUrl});
  background-size: cover;
  background-position: center;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
  height: 250px;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  }
`;

const TextOverlay = styled.div`
  background: rgba(0, 0, 0, 0.6);
  padding: 15px;
  width: 100%;
  box-sizing: border-box;
`;

const CriticName = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: white;
  margin: 0;
  padding-top: 10px;
`;

const KriticCard = ({ critic, maxMatchScore }) => {
  const imageUrl = `https://i.pravatar.cc/300?u=${critic.site_identifier}`;

  return (
    <CardLink to={`/kritics/${critic.site_identifier}`}>
      <Card imageUrl={imageUrl}>
        <TextOverlay>
          <MatchScoreIndicator score={critic.match_score} maxScore={maxMatchScore} textColor="white" />
          <CriticName>{critic.name}</CriticName>
        </TextOverlay>
      </Card>
    </CardLink>
  );
};

export default KriticCard;
